var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "rbvp-condition-editor",
      class: [`depth-${_vm.depth}`, _vm.internalCondition.matcherKind],
    },
    [
      _c("div", { staticClass: "rbvp-condition-header" }, [
        _c("div", { staticClass: "rbvp-condition-badge" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.internalCondition.matcherKind === "logic"
                  ? "逻辑组合"
                  : "基础匹配"
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _vm.allowRemove
          ? _c(
              "button",
              {
                staticClass: "rbvp-condition-remove",
                attrs: { type: "button", title: "删除条件" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("remove")
                  },
                },
              },
              [_vm._v("\n      删除\n    ")]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.internalCondition.matcherKind === "basic"
        ? [
            _c("div", { staticClass: "rbvp-condition-grid" }, [
              _c(
                "label",
                { staticClass: "rbvp-condition-field" },
                [
                  _c("span", { staticClass: "rbvp-condition-label" }, [
                    _vm._v("规则类型"),
                  ]),
                  _vm._v(" "),
                  _c("VDropdown", {
                    attrs: {
                      items: _vm.visualMatcherTypes,
                      "key-mapper": (item) => item,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item",
                          fn: function ({ item }) {
                            return [_vm._v(_vm._s(item))]
                          },
                        },
                      ],
                      null,
                      false,
                      1280491791
                    ),
                    model: {
                      value: _vm.localMatcherType,
                      callback: function ($$v) {
                        _vm.localMatcherType = $$v
                      },
                      expression: "localMatcherType",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.internalCondition.matcherType !== "FINAL"
                ? _c(
                    "label",
                    { staticClass: "rbvp-condition-field" },
                    [
                      _c("span", { staticClass: "rbvp-condition-label" }, [
                        _vm._v("匹配参数"),
                      ]),
                      _vm._v(" "),
                      _vm.internalCondition.matcherType === "RULE-SET"
                        ? _c("VDropdown", {
                            attrs: {
                              items: _vm.ruleSetNames,
                              "key-mapper": (item) => item,
                              disabled: _vm.ruleSetNames.length === 0,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item",
                                  fn: function ({ item }) {
                                    return [_vm._v(_vm._s(item))]
                                  },
                                },
                              ],
                              null,
                              false,
                              1280491791
                            ),
                            model: {
                              value: _vm.localMatcherArgument,
                              callback: function ($$v) {
                                _vm.localMatcherArgument = $$v
                              },
                              expression: "localMatcherArgument",
                            },
                          })
                        : _c("TextBox", {
                            attrs: {
                              validator: (v) => v.trim(),
                              placeholder: _vm.getMatcherArgumentPlaceholder(
                                _vm.internalCondition.matcherType
                              ),
                            },
                            model: {
                              value: _vm.localMatcherArgument,
                              callback: function ($$v) {
                                _vm.localMatcherArgument = $$v
                              },
                              expression: "localMatcherArgument",
                            },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "rbvp-condition-hint" }, [
              _vm._v(
                _vm._s(
                  _vm.getMatcherTypeHint(_vm.internalCondition.matcherType)
                )
              ),
            ]),
          ]
        : [
            _c("div", { staticClass: "rbvp-condition-grid" }, [
              _c(
                "label",
                { staticClass: "rbvp-condition-field" },
                [
                  _c("span", { staticClass: "rbvp-condition-label" }, [
                    _vm._v("逻辑运算"),
                  ]),
                  _vm._v(" "),
                  _c("VDropdown", {
                    attrs: {
                      items: _vm.logicMatcherTypes,
                      "key-mapper": (item) => item,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item",
                        fn: function ({ item }) {
                          return [_vm._v(_vm._s(item))]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.localLogicOperator,
                      callback: function ($$v) {
                        _vm.localLogicOperator = $$v
                      },
                      expression: "localLogicOperator",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "rbvp-condition-hint" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.getLogicMatcherHint(_vm.internalCondition.logicOperator)
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "rbvp-condition-children" },
              [
                _vm.internalCondition.conditions.length === 0
                  ? _c("div", { staticClass: "rbvp-condition-empty" }, [
                      _vm._v(
                        "\n        还没有子条件，请新增一个基础匹配或逻辑组合。\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(
                  _vm.internalCondition.conditions,
                  function (child, index) {
                    return _c("RBVPLogicConditionEditor", {
                      key: child.id,
                      attrs: {
                        "default-matcher-arguments":
                          _vm.defaultMatcherArguments,
                        "rule-set-names": _vm.ruleSetNames,
                        "visual-matcher-types": _vm.visualMatcherTypes,
                        "logic-matcher-types": _vm.logicMatcherTypes,
                        depth: _vm.depth + 1,
                        "allow-remove": "",
                      },
                      on: {
                        input: _vm.emitChange,
                        remove: function ($event) {
                          return _vm.removeChild(index)
                        },
                      },
                      model: {
                        value: _vm.internalCondition.conditions[index],
                        callback: function ($$v) {
                          _vm.$set(_vm.internalCondition.conditions, index, $$v)
                        },
                        expression: "internalCondition.conditions[index]",
                      },
                    })
                  }
                ),
                _vm._v(" "),
                _vm.showInsertChooser
                  ? _c("div", { staticClass: "rbvp-condition-insert" }, [
                      _c(
                        "button",
                        {
                          staticClass: "rbvp-condition-choice",
                          attrs: { type: "button" },
                          on: { click: _vm.addBasicChild },
                        },
                        [_vm._v("\n          新增基础匹配\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "rbvp-condition-choice",
                          attrs: { type: "button" },
                          on: { click: _vm.addLogicChild },
                        },
                        [_vm._v("\n          新增逻辑组合\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "rbvp-condition-cancel",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.showInsertChooser = false
                            },
                          },
                        },
                        [_vm._v("\n          取消\n        ")]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "rbvp-condition-add",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.showInsertChooser = !_vm.showInsertChooser
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.showInsertChooser ? "收起新增入口" : "新增子条件"
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }